/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Modules_Add_RentInputs */

const cs_clients_modules_add_rent = /** @type {(inputs: Clients_Modules_Add_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat poptávku pronájmu`)
};

const en_clients_modules_add_rent = /** @type {(inputs: Clients_Modules_Add_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add rent demand`)
};

/**
* | output |
* | --- |
* | "Add rent demand" |
*
* @param {Clients_Modules_Add_RentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_modules_add_rent = /** @type {((inputs?: Clients_Modules_Add_RentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Modules_Add_RentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_modules_add_rent(inputs)
	return cs_clients_modules_add_rent(inputs)
});